import { useEffect } from "react"

const useScript = (src: string): void => {
  useEffect(() => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return
    }
    const script = document.createElement("script")
    script.src = src
    script.async = true
    document.body.appendChild(script)
  }, [src])
}

export default useScript
